module.exports = __webpack_public_path__ + "img/arrow-right.29076efc.svg";